// src/modules/components/HeaderCADPro/styles.js
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const colors = {
  background: '#0D0D0D',
  backgroundAlt: '#111111',
  primary: '#00A8E8',
  primaryDark: '#0077B6',
  success: '#2ECC71',
  textPrimary: '#FFFFFF',
  textSecondary: 'rgba(255, 255, 255, 0.85)',
  textMuted: 'rgba(255, 255, 255, 0.6)',
  border: 'rgba(255, 255, 255, 0.08)',
  white: '#FFFFFF'
};

const breakpoints = {
  mobile: '576px',
  tablet: '768px',
  laptop: '1024px'
};

export const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: ${props => props.isScrolled ? 
    'rgba(13, 13, 13, 0.98)' : 
    'rgba(13, 13, 13, 0.9)'
  };
  border-bottom: 1px solid ${colors.border};
  backdrop-filter: blur(20px);
  transition: all 0.3s ease;
`;

export const HeaderContent = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 64px;

  @media (max-width: ${breakpoints.mobile}) {
    padding: 0 1rem;
    height: 56px;
  }
`;

export const Logo = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
  z-index: 1001;
  
  img {
    height: 36px;
    width: auto;
    transition: all 0.3s ease;
  }
  
  &:hover img {
    opacity: 0.9;
  }

  @media (max-width: ${breakpoints.mobile}) {
    img {
      height: 30px;
    }
  }
`;

export const Navigation = styled.nav`
  display: flex;
  align-items: center;
  gap: 2rem;

  @media (max-width: ${breakpoints.tablet}) {
    display: none;
  }
`;

export const NavLink = styled.a`
  color: ${colors.textMuted};
  text-decoration: none;
  font-weight: 500;
  font-size: 0.85rem;
  transition: all 0.3s ease;
  position: relative;
  padding: 0.25rem 0;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: ${colors.primary};
    transform: scaleX(0);
    transition: transform 0.3s ease;
  }

  &:hover {
    color: ${colors.textPrimary};
    
    &::after {
      transform: scaleX(1);
    }
  }
`;

export const AuthButtons = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: ${breakpoints.tablet}) {
    display: none;
  }
`;

export const ContactButton = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 1.25rem;
  background: ${colors.primary};
  color: ${colors.white};
  text-decoration: none;
  font-weight: 600;
  font-size: 0.8rem;
  border-radius: 6px;
  transition: all 0.3s ease;

  &:hover {
    background: ${colors.primaryDark};
    transform: translateY(-1px);
    box-shadow: 0 4px 15px rgba(0, 168, 232, 0.3);
  }

  svg {
    font-size: 0.9rem;
  }
`;

export const MobileMenuButton = styled.button`
  display: none;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: none;
  border: 1px solid ${colors.border};
  color: ${colors.textPrimary};
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(0, 168, 232, 0.1);
    border-color: ${colors.primary};
  }

  svg {
    font-size: 1.1rem;
  }

  @media (max-width: ${breakpoints.tablet}) {
    display: flex;
  }
`;

export const MobileMenu = styled.div`
  position: fixed;
  top: 64px;
  left: 0;
  right: 0;
  bottom: 0;
  background: #0D0D0D;
  background-color: #0D0D0D;
  z-index: 999;
  padding: 1rem;
  opacity: ${props => props.isOpen ? 1 : 0};
  visibility: ${props => props.isOpen ? 'visible' : 'hidden'};
  transform: translateY(${props => props.isOpen ? '0' : '-10px'});
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  overflow-y: auto;

  @media (min-width: ${breakpoints.tablet}) {
    display: none;
  }

  @media (max-width: ${breakpoints.mobile}) {
    top: 56px;
  }
`;

export const MobileNavItem = styled.a`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  color: ${colors.textSecondary};
  text-decoration: none;
  font-weight: 500;
  font-size: 1rem;
  border-bottom: 1px solid ${colors.border};
  transition: all 0.3s ease;

  svg {
    font-size: 0.75rem;
    color: ${colors.textMuted};
    transition: all 0.3s ease;
  }

  &:hover, &:active {
    color: ${colors.primary};
    background: rgba(0, 168, 232, 0.05);
    
    svg {
      color: ${colors.primary};
      transform: translateX(4px);
    }
  }
`;

export const MobileContactArea = styled.div`
  margin-top: auto;
  padding: 1.5rem 0;
  
  ${ContactButton} {
    width: 100%;
    justify-content: center;
    padding: 1rem;
    font-size: 0.9rem;
  }
`;